var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    {
      ref: "footerH",
      staticClass: "footer",
      class: { footerBgr: _vm.stickyBetslip }
    },
    [
      _vm.brandKey === "boyd"
        ? [
            _c("div", { staticClass: "good_to_be_connected" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/footer.png"
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "footer_nav" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_ABOUT" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "footer_contact" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.$t("Footer.contact_line_1")) }
              })
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "footer-bottom" }, [
              _c(
                "div",
                { staticClass: "footer_copyright" },
                [
                  _c("span", { staticClass: "copy_text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Footer.copyright", {
                          currentYear: _vm.currentYear
                        })
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v("remove")]),
                  _vm._v(" "),
                  _c("site-navigation", {
                    attrs: { "navigation-section": "FOOTER_TERMS" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.buildVersion
                ? _c("div", { staticClass: "build_version_text" }, [
                    _vm._v(_vm._s(_vm.buildVersion))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "back-to-top",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("expand_less")])],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey === "rw"
        ? [
            _c("div", { staticClass: "footer_logo" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer("/static/brand-img/rw/logo-circle.svg"),
                  alt: "rw"
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "igt_footer_nav" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_ABOUT" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "bottom-info" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("Footer.info.companyName", {
                      currentYear: _vm.currentYear
                    })
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("Footer.info.gamblingProblem")))]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "rg",
                  attrs: {
                    href: "https://www.nevadacouncil.org/responsible-gaming/"
                  }
                },
                [
                  _c("img", {
                    staticClass: "rg-logo",
                    attrs: {
                      src: _vm.mediaServer(
                        "/static/brand-img/" + _vm.brandKey + "/rg-logo.svg"
                      ),
                      alt: "rg"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "header-txt" }, [
                    _vm._v(_vm._s(_vm.$t("Header.InfoMessageTwo")))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.buildVersion
                ? _c("p", { staticClass: "build_version_text" }, [
                    _vm._v(_vm._s(_vm.buildVersion))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "footer-bottom" }, [
              _c(
                "section",
                {
                  staticClass: "back-to-top",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("expand_less")])],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey === "dn" || _vm.brandKey === "dnw"
        ? [
            _c("div", { staticClass: "footer-holder" }, [
              _c("div", { staticClass: "footer-content" }, [
                _c(
                  "section",
                  { staticClass: "footer_nav section about" },
                  [
                    _c("site-navigation", {
                      attrs: { "navigation-section": "FOOTER_ABOUT" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("section", { staticClass: "footer_contact section" }, [
                  _c(
                    "section",
                    { staticClass: "footer_nav section support" },
                    [
                      _c("site-navigation", {
                        attrs: { "navigation-section": "FOOTER_SUPPORT" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "footer-address section" }, [
                  _c("div", { staticClass: "logos" }, [
                    _c("span", [
                      _c("img", {
                        attrs: {
                          src: _vm.mediaServer(
                            "/static/brand-img/" +
                              _vm.brandKey +
                              "/secondary-logo-white.png"
                          )
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "footer_nav section address" },
                    [
                      _c("site-navigation", {
                        attrs: { "navigation-section": "FOOTER_ADDRESS" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "footer_social section" }, [
                  _c(
                    "section",
                    { staticClass: "footer_nav section social-icons" },
                    [
                      _c("site-navigation", {
                        attrs: { "navigation-section": "FOOTER_SOCIAL_ICONS" }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer_bottom_holder" }, [
              _c("div", { staticClass: "footer-holder" }, [
                _c("div", { staticClass: "footer-responsible section" }, [
                  _c("div", { staticClass: "lottery-logo" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.mediaServer(
                          "/static/brand-img/" +
                            _vm.brandKey +
                            "/wv-lottery-logo-black.png"
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "responsible_text" }, [
                    _vm._v(_vm._s(_vm.$t("Footer.responsible")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lottery-logo-primary" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.mediaServer(
                          "/static/brand-img/" +
                            _vm.brandKey +
                            "/delaware-north.png"
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.buildVersion
                    ? _c("div", { staticClass: "build_version_text" }, [
                        _vm._v(_vm._s(_vm.buildVersion))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "footer-bottom" }, [
                  _c(
                    "div",
                    {
                      staticClass: "back-to-top",
                      on: {
                        click: function($event) {
                          return _vm.goBack()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("expand_less")])],
                    1
                  )
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey === "circa"
        ? [
            !_vm.mobileBigAndBelow
              ? _c(
                  "div",
                  { staticClass: "footer_nav" },
                  [
                    _c("site-navigation", {
                      attrs: { "navigation-section": "FOOTER_ABOUT" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileBigAndBelow
              ? _c("div", { staticClass: "rg-footer" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("Footer.InfoMessageOne")))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("Footer.InfoMessageTwo")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "logo-holder" }, [
                    _c(
                      "a",
                      { attrs: { href: "https://www.ncpgambling.org/" } },
                      [
                        _c("img", {
                          staticClass: "rg-logo",
                          attrs: {
                            src: _vm.mediaServer(
                              "/static/brand-img/circa/rg-logo.svg"
                            ),
                            alt: "rg"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Footer.InfoMessageThree")))
                        ])
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("section", { staticClass: "footer-bottom" }, [
              _c("div", { staticClass: "footer_copyright" }, [
                _c("span", { staticClass: "copy_text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Footer.copyright", {
                        currentYear: _vm.currentYear
                      })
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.buildVersion
                  ? _c("div", { staticClass: "build_version_text" }, [
                      _vm._v(_vm._s(_vm.buildVersion))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "back-to-top",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("expand_less")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.$t("Footer.BackToTop")))
                  ])
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey === "sb" || _vm.brandKey === "mav"
        ? [
            _c("div", { staticClass: "footer_logo" }, [
              _vm.brandKey === "sb"
                ? _c("img", {
                    attrs: {
                      src: _vm.mediaServer(
                        "/static/brand-img/sb/logo-footer.png"
                      ),
                      alt: "sb"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.brandKey === "mav"
                ? _c("img", {
                    attrs: {
                      src: _vm.mediaServer(
                        "/static/brand-img/" + _vm.brandKey + "/footer-logo.png"
                      ),
                      alt: "mav"
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "footer_social" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_SOCIAL_ICONS" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.brandKey === "mav" && !_vm.mobileBigAndBelow
              ? _c("div", { staticClass: "rg-footer" }, [
                  _c("div", {
                    staticClass: "footer_info",
                    domProps: { innerHTML: _vm._s(_vm.$t("Footer.info")) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.mobileBigAndBelow && _vm.brandKey === "sb"
              ? _c("div", {
                  staticClass: "footer_info",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("Footer.info." + _vm.state, {
                        mediaRGImg: _vm.mediaServer(
                          "/static/brand-img/" + _vm.brandKey + "/rg-logo.svg"
                        )
                      })
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileBigAndBelow
              ? _c(
                  "div",
                  { staticClass: "rg-footer" },
                  [
                    _vm.brandKey === "sb" && _vm.state !== "VA"
                      ? [
                          _vm.brandKey === "sb"
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("Footer.InfoMessageOne")))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brandKey === "sb"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Footer.InfoMessageTwo." + _vm.state)
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brandKey === "sb"
                            ? _c("div", { staticClass: "logo-holder" }, [
                                _vm.state === "NJ"
                                  ? _c("img", {
                                      staticClass: "rg-logo nj",
                                      attrs: {
                                        src: _vm.mediaServer(
                                          "/static/brand-img/" +
                                            _vm.brandKey +
                                            "/rg-logo-nj.svg"
                                        ),
                                        alt: "rg"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.go2ResponsibleGaming.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _c("img", {
                                      staticClass: "rg-logo",
                                      attrs: {
                                        src: _vm.mediaServer(
                                          "/static/brand-img/" +
                                            _vm.brandKey +
                                            "/rg-logo.svg"
                                        ),
                                        alt: "rg"
                                      }
                                    }),
                                _vm._v(" "),
                                _vm.state === "CO"
                                  ? _c("span", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "http://problemgamblingcolorado.org/"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Footer.InfoMessageThree")
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.state === "AZ"
                                  ? _c("span", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "https://problemgambling.az.gov/"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Footer.InfoMessageThree")
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.state === "IA"
                                  ? _c("span", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "https://idph.iowa.gov/igtp"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Footer.InfoMessageThree")
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.state === "NJ"
                                  ? _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.go2ResponsibleGaming.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Footer.InfoMessageThree")
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.state === "TN"
                                  ? _c("span", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "https://www.tn.gov/behavioral-health/substance-abuse-services/treatment---recovery/treatment---recovery/problem-gambling-programs.html"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Footer.InfoMessageThree")
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.state === "VA"
                                  ? _c("span", [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "https://vcpg.net/" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Footer.InfoMessageThree")
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandKey === "sb" && _vm.state === "VA"
                      ? [
                          _c("span", { staticClass: "m-b-7" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Footer.InfoMessages.Superbook.VA.One")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-b-7" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Footer.InfoMessages.Superbook.VA.Two")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-b-7" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Footer.InfoMessages.Superbook.VA.Three")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-b-7" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Footer.InfoMessages.Superbook.VA.Four")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-b-7" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Footer.InfoMessages.Superbook.VA.Five")
                              )
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "tel:" +
                                    _vm.$t(
                                      "Footer.InfoMessages.Superbook.VA.Five.Phone"
                                    )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Footer.InfoMessages.Superbook.VA.Five.Phone"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Footer.InfoMessages.Superbook.VA.Five.End"
                                )
                              )
                            ),
                            _c("a", { attrs: { href: "https://vcpg.net" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Footer.InfoMessages.Superbook.VA.Link1"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "m-b-7" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://www.valottery.com/playingmatters/voluntaryexclusionprogram"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Footer.InfoMessages.Superbook.VA.Link2"
                                    )
                                  )
                                )
                              ]
                            )
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("div", { staticClass: "logo-holder" }, [
                            _c("img", {
                              staticClass: "rg-logo",
                              attrs: {
                                src: _vm.mediaServer(
                                  "/static/brand-img/" +
                                    _vm.brandKey +
                                    "/rg-logo.svg"
                                ),
                                alt: "rg"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _c(
                                "a",
                                { attrs: { href: "https://vcpg.net/" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Footer.InfoMessageThree"))
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandKey === "mav"
                      ? _c("div", { staticClass: "logo-holder" }, [
                          _c("span", [
                            _c(
                              "a",
                              {
                                attrs: { href: "https://www.ncpgambling.org/" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Footer.InfoMessageThree"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "rg-logo",
                            attrs: {
                              src: _vm.mediaServer(
                                "/static/brand-img/" +
                                  _vm.brandKey +
                                  "/rg-logo-white.svg"
                              ),
                              alt: "rg"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Footer.InfoMessageOne")))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Footer.InfoMessageTwo." + _vm.state)
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "igt_footer_nav" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_ABOUT" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "footer-bottom" }, [
              _c("div", { staticClass: "footer_copyright" }, [
                _vm.brandKey === "sb"
                  ? _c("span", { staticClass: "copy_text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Footer.copyright." + _vm.state, {
                            currentYear: _vm.currentYear
                          })
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.brandKey === "mav"
                  ? _c("span", { staticClass: "copy_text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Footer.copyright", {
                            currentYear: _vm.currentYear
                          })
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.state === "NJ" && _vm.isLoggedIn
                  ? _c("div", { staticClass: "current-time" }, [
                      _vm._v(
                        _vm._s(_vm.$t("MyAccount.SessionTime." + _vm.state)) +
                          " " +
                          _vm._s(_vm.sessionTime)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.state === "NJ"
                  ? _c("div", { staticClass: "current-time" }, [
                      _vm._v(_vm._s(_vm.currentTime))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.buildVersion
                  ? _c("div", { staticClass: "build_version_text" }, [
                      _vm._v(_vm._s(_vm.buildVersion))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "back-to-top",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("expand_less")])],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey === "qcasino" || _vm.brandKey === "pr"
        ? [
            _c("div", { staticClass: "footer_logo" }, [
              _c("img", {
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" + _vm.brandKey + "/footer-logo.png"
                  ),
                  alt: "logo"
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "footer_social" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_SOCIAL_ICONS" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.mobileBigAndBelow
              ? _c("div", { staticClass: "rg-footer" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("Footer.InfoMessageOne")))]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Footer.InfoMessageTwo." + _vm.state)))
                  ]),
                  _vm._v(" "),
                  _vm.brandKey === "qcasino"
                    ? _c("div", { staticClass: "logo-holder" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "https://yourlifeiowa.org/gambling" }
                          },
                          [
                            _c("img", {
                              staticClass: "rg-logo",
                              attrs: {
                                src: _vm.mediaServer(
                                  "/static/brand-img/" +
                                    _vm.brandKey +
                                    "/rg-logo.svg"
                                ),
                                alt: "rg"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://yourlifeiowa.org/gambling"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Footer.InfoMessageThree")))]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.brandKey === "pr"
                    ? _c("div", { staticClass: "logo-holder" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://msgaming.org/responsible-gaming/"
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "rg-logo",
                              attrs: {
                                src: _vm.mediaServer(
                                  "/static/brand-img/" +
                                    _vm.brandKey +
                                    "/rg-logo.svg"
                                ),
                                alt: "rg"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://msgaming.org/responsible-gaming/"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Footer.InfoMessageThree")))]
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "igt_footer_nav" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_ABOUT" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "footer-bottom" }, [
              _c("div", { staticClass: "footer_copyright" }, [
                _c("span", { staticClass: "copy_text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Footer.copyright", {
                        currentYear: _vm.currentYear
                      })
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "back-to-top",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("expand_less")])],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandLayout === "generic" && _vm.brandKey !== "generic-rilot"
        ? [
            _c(
              "div",
              { staticClass: "footer_social" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_SOCIAL_ICONS" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "igt_footer_nav" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_ABOUT" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "bottom-info" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t("Footer.info.companyName", {
                      currentYear: _vm.currentYear
                    })
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("Footer.info.gamblingProblem")))]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "rg",
                  attrs: {
                    target: _vm.isMobileApp ? "_self" : "_blank",
                    href: _vm.rgLink
                  }
                },
                [
                  _c("img", {
                    staticClass: "rg-logo",
                    attrs: {
                      src: _vm.mediaServer(
                        "/static/brand-img/" + _vm.brandKey + "/rg-logo.svg"
                      ),
                      alt: "rg"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "header-txt" }, [
                    _vm._v(_vm._s(_vm.$t("Header.InfoMessageTwo")))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.buildVersion
                ? _c("p", { staticClass: "build_version_text" }, [
                    _vm._v(_vm._s(_vm.buildVersion))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "footer-bottom" }, [
              _c(
                "section",
                {
                  staticClass: "back-to-top",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("expand_less")])],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.brandKey === "generic-rilot"
        ? [
            _c("div", { staticClass: "footer-top footercontent" }, [
              _c("div", { staticClass: "footer-top-left" }, [
                _c("section", { staticClass: "company-pr" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("Footer.playResponsiblyTitle")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "desc" }, [
                    _vm._v(_vm._s(_vm.$t("Footer.playResponsiblyDesc")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "link" },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.mediaServer(
                            "/static/brand-img/generic-rilot/footer/gamble-banner.png"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "info",
                              params: { infopagename: "responsible-gaming" }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Footer.FindOutMore")))]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer-top-right" }, [
                _c("section", { staticClass: "social_and_contact" }, [
                  _c(
                    "section",
                    { staticClass: "contact_us" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "info",
                              params: { infopagename: "contact" }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Footer.ContactUs")))]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "partners" },
                  [
                    _c("site-navigation", {
                      attrs: { "navigation-section": "PARTNERS" }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "ri-ocean-state" }, [
              _c("section", { staticClass: "footercontent" }, [
                _c("div", { staticClass: "col-left" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.mediaServer(
                        "/static/brand-img/generic-rilot/footer/ri-badge.jpg"
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-right" }, [
                  _vm._v(_vm._s(_vm.$t("Footer.oceanState")))
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "footer-bottom" }, [
                _c("div", { staticClass: "bottom-info" }, [
                  !_vm.isMobileApp
                    ? _c(
                        "div",
                        { staticClass: "app-links" },
                        [
                          _c("site-navigation", {
                            attrs: { "navigation-section": "LINK_TO_APPS" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "igt_footer_nav" },
              [
                _c("site-navigation", {
                  attrs: { "navigation-section": "FOOTER_ABOUT" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "footer-bottom" }, [
              _c("div", { staticClass: "bottom-info" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Footer.info.companyName", {
                        currentYear: _vm.currentYear
                      })
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.buildVersion
                  ? _c("p", { staticClass: "build_version_text" }, [
                      _vm._v(_vm._s(_vm.buildVersion))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "back-to-top",
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("expand_less")])],
                1
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-503caf7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503caf7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/FooterPart.vue
// module id = null
// module chunks = 